<script>
// import Translations from "./insert-me-to-translate.vue";

import Recaptcha from './recaptcha';
import Hcaptcha from './hcaptcha';
import Turnstile from './turnstile';
import {mapGetters} from "vuex";
import {isValidEmail} from "../services/email_validator";

export default {
    props: [ 'initLoadRecaptcha','addEmailUrl'],
    components: {
        Recaptcha,
        Hcaptcha,
        Turnstile,
    },
    data: function(){
        return  {
            email: '',
            emailError: '',
            recaptchaError: '',
            loadRecaptcha: this.initLoadRecaptcha,
            isRecaptchaFilled: true,
            waitingServerResponse: false,
        };
    },
    computed: {
        ...mapGetters({
            isRecaptchaReady: 'ui/recaptcha/isReady',
            recaptchaResponse: 'ui/recaptcha/response',
        }),
    },
    mounted(){
            $('#addmail').on("hidden.bs.modal", this.resetModal)
    },
    methods: {
        add: function(event){

            this.emailError = '';
            this.recaptchaError = ''
            if (this.loadRecaptcha) {
                this.isRecaptchaFilled = !!this.recaptchaResponse;
            } else {
                this.isRecaptchaFilled = true
            }
            if(!this.waitingServerResponse && isValidEmail(this.email.trim()) && this.isRecaptchaFilled){
                this.waitingServerResponse = true;
                let data_form = {
                        'email': this.email.trim(),
                        'g-recaptcha-response': this.recaptchaResponse,
                    }
                if (typeof(turnstile) !== "undefined") {
                  data_form = {
                    'email': this.email,
                    'cf-turnstile-response': this.recaptchaResponse,
                  }
                }
                else if (typeof(hcaptcha) !== "undefined") {
                  data_form = {
                    'email': this.email,
                    'h-captcha-response': this.recaptchaResponse,
                  }
                }

                this.$http.post(
                    this.addEmailUrl,
                    data_form
                ).then((response)=>{
                    if(response.status===204){
                        $('#addmail').modal('show')
                    }else{
                        this.emailError = gettext('An unexpected error has occurred')
                    }
                }).catch((error)=>{
                    if(error.response && error.response.status===409){
                        this.emailError = gettext('The email is already added. Try to check the list of verified emails below')
                    }else if(error.response && error.response.status===406){
                        this.emailError = gettext('This is not a valid email')
                    }else{
                        this.emailError = gettext('An unexpected error has occurred')
                    }

                }).finally(() => {

                    // go to first error after dom updates
                    this.$nextTick().then(()=>{
                        this.$skokka.scrollToError();
                    });

                    this.waitingServerResponse = false;
                    if (this.loadRecaptcha) {
                        if (typeof(hcaptcha) !== "undefined") {
                          hcaptcha.reset();
                        }
                        else if (typeof(turnstile) !== "undefined") {
                          turnstile.reset();
                        }
                        else{
                          grecaptcha.reset();
                        }
                    }
                });
            }else{
                if(!this.email.trim()){
                    this.emailError = gettext('Please fill in this field');
                } else if(!isValidEmail(this.email.trim())){
                    this.emailError = gettext('This is not a valid email');
                }
                if(!this.isRecaptchaFilled){
                    this.recaptchaError = gettext('Please fill in this field')
                }

            }
            // go to first error after dom updates
              this.$nextTick().then(()=>{
                  this.$skokka.scrollToError();
              });

        },
        resetModal:function(event){
            this.email=''
        }
    }
};

</script>
